import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePrintConfigStore = defineStore('printConfig', () => {
  const paperWidth = ref('48')
  const setPaperWidth = (width: string) => {
    paperWidth.value = width
  }

  return { paperWidth, setPaperWidth }
})
